/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { LineSeries } from '@nivo/line';

import { CIFonts } from 'shared';

export interface ChartDimensions {
  width: number;
  height: number;
}

export interface ChartMargin {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

export type BaseLineChartData = LineSeries & {
  color: string;
};

export interface BaseChartData {
  id: string;
  label: string;
  value: number;
  color: string;
}

export interface StorageChartData extends BaseChartData {
  memory: string;
}

export const defaultChartDimensions: ChartDimensions = {
  width: 225,
  height: 225,
};

export const defaultChartMargin: ChartMargin = {
  top: 20,
  right: 0,
  bottom: 20,
  left: 0,
};

export const defaultPieConfig = {
  innerRadius: 0.3,
  padAngle: 2,
  cornerRadius: 3,
  activeOuterRadiusOffset: 3,
  borderWidth: 1,
  borderColor: {
    from: 'color',
    modifiers: [['darker', 0.2] as ['darker', number]],
  },
  enableArcLabels: false,
  enableArcLinkLabels: false,
  legends: [],
};

export const defaultChartTheme = {
  text: {
    fontFamily: CIFonts.Text,
    fontSize: 14,
  },
};
